import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserdataService {

  private userdatasubject: BehaviorSubject<any> = new BehaviorSubject(null);
  private userdata: any = null;

  getUserData() {
    return this.userdata;
  }
  getUserDataSubject() {
    return this.userdatasubject;
  }

  setUserData(Obj) {
    this.userdata = Obj;
    this.userdatasubject.next(Obj);
  }

  constructor() { }
}
